"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasValidToken = void 0;
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var jwtTokenKey = 'jwtToken';
var getToken = function () {
    var jwtTokenValue = sessionStorage.getItem(jwtTokenKey);
    if (!jwtTokenValue)
        return null;
    return jwt_decode_1.default(jwtTokenValue);
};
var removeToken = function () {
    sessionStorage.clear();
};
var hasValidToken = function () {
    var jwtToken = getToken();
    var secondsUntilTokenExpires = jwtToken && Math.floor(jwtToken.exp - Date.now() / 1000);
    if (secondsUntilTokenExpires > 0)
        return true;
    removeToken();
    return false;
};
exports.hasValidToken = hasValidToken;
